export function SettingsStyles({ isDark, accent }) {
  return (
    <style>{`
      .settings-page {
        max-width: 720px;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        gap: 20px;
        padding-bottom: 40px;
      }

      .s-header { display: flex; align-items: flex-start; justify-content: space-between; }
      .s-title { font-size: 32px; font-weight: 700; color: ${isDark ? '#fff' : '#111'}; }
      .s-subtitle { color: ${isDark ? '#9CA3AF' : '#6B7280'}; font-size: 14px; margin-top: 4px; }
      .s-save-top {
        background: #FF4500; color: #fff; border: none; border-radius: 10px;
        padding: 10px 20px; font-weight: 600; font-size: 14px; cursor: pointer;
        transition: opacity 0.2s;
      }
      .s-save-top:hover { opacity: 0.9; }
      .s-save-top:disabled { opacity: 0.5; }

      .s-card {
        background: ${isDark ? '#1A1A1A' : '#ffffff'};
        border: 1px solid ${isDark ? '#2A2A2A' : '#E5E7EB'};
        border-radius: 16px;
        padding: 24px;
      }

      .s-profile-card { display: flex; align-items: center; gap: 24px; }
      .s-avatar-block { display: flex; flex-direction: column; align-items: center; gap: 6px; cursor: pointer; }
      .s-avatar { position: relative; overflow: hidden; }
      .s-avatar-logo {
        width: 80px; height: 80px; border-radius: 16px;
        background: #FF4500; display: flex; align-items: center; justify-content: center;
      }
      .s-avatar-photo {
        width: 64px; height: 64px; border-radius: 50%;
        background: ${isDark ? '#1F2937' : '#D1D5DB'}; display: flex; align-items: center; justify-content: center;
      }
      .s-avatar-img { width: 100%; height: 100%; object-fit: cover; }
      .s-avatar-initials { color: #fff; font-size: 28px; font-weight: 700; }
      .s-avatar-initials.small { font-size: 20px; color: ${isDark ? '#fff' : '#374151'}; }
      .s-avatar-overlay {
        position: absolute; inset: 0;
        background: rgba(0,0,0,0.6);
        display: flex; flex-direction: column; align-items: center; justify-content: center;
        gap: 2px; opacity: 0; transition: opacity 0.2s;
        color: #fff; font-size: 11px;
      }
      .s-avatar-block:hover .s-avatar-overlay { opacity: 1; }
      .s-avatar-label { font-size: 11px; color: ${isDark ? '#9CA3AF' : '#6B7280'}; }

      .s-profile-center { flex: 1; min-width: 0; }
      .s-profile-name { font-size: 20px; font-weight: 700; color: ${isDark ? '#fff' : '#111'}; }
      .s-plan-badge {
        display: inline-block; margin-top: 4px;
        background: rgba(255,69,0,0.12); color: #FF4500;
        border-radius: 20px; font-size: 10px; font-weight: 700;
        padding: 3px 10px;
      }
      .s-profile-url {
        display: flex; align-items: center; gap: 6px; margin-top: 6px;
        font-size: 12px; color: #FF7744;
      }
      .s-profile-url span { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
      .s-copy-mini {
        background: none; border: none; color: ${isDark ? '#9CA3AF' : '#6B7280'};
        cursor: pointer; padding: 2px; flex-shrink: 0;
      }
      .s-copy-mini:hover { color: ${isDark ? '#fff' : '#111'}; }

      .s-card-header { display: flex; align-items: center; justify-content: space-between; margin-bottom: 4px; }
      .s-card-title-row { display: flex; align-items: center; gap: 8px; }
      .s-card-title { font-size: 16px; font-weight: 600; color: ${isDark ? '#fff' : '#111'}; }
      .s-card-subtitle { color: ${isDark ? '#9CA3AF' : '#6B7280'}; font-size: 12px; margin-bottom: 16px; }

      .s-outlined-btn {
        display: flex; align-items: center; gap: 6px;
        background: transparent; border: 1px solid ${isDark ? '#2A2A2A' : '#D1D5DB'};
        color: ${isDark ? '#9CA3AF' : '#6B7280'}; border-radius: 8px;
        padding: 6px 14px; font-size: 12px; cursor: pointer; transition: all 0.2s;
      }
      .s-outlined-btn:hover { border-color: ${isDark ? '#555' : '#9CA3AF'}; color: ${isDark ? '#fff' : '#111'}; }
      .s-accent-btn {
        display: flex; align-items: center; gap: 6px;
        background: #FF4500; color: #fff; border: none; border-radius: 10px;
        padding: 8px 18px; font-size: 13px; font-weight: 600; cursor: pointer;
      }
      .s-accent-btn:disabled { opacity: 0.5; }
      .s-whatsapp-btn {
        display: flex; align-items: center; gap: 6px;
        background: #25D366; color: #fff; border: none; border-radius: 10px;
        padding: 8px 16px; font-size: 13px; cursor: pointer;
      }
      .s-whatsapp-btn:hover { opacity: 0.9; }
      .s-text-btn {
        display: inline-flex; align-items: center; gap: 4px;
        background: none; border: none; color: ${isDark ? '#6B7280' : '#9CA3AF'};
        font-size: 12px; cursor: pointer;
      }
      .s-text-btn:hover { color: ${isDark ? '#fff' : '#111'}; }
      .s-text-btn.danger { color: #EF4444; }

      .s-row { padding: 12px 0; border-bottom: 1px solid ${isDark ? '#2A2A2A' : '#E5E7EB'}; }
      .s-row:last-child { border-bottom: none; }
      .s-row-label {
        display: block; font-size: 10px; text-transform: uppercase;
        letter-spacing: 0.08em; color: ${isDark ? '#6B7280' : '#9CA3AF'}; margin-bottom: 4px;
      }
      .s-row-value { font-size: 14px; color: ${isDark ? '#fff' : '#111'}; }
      .s-empty { color: ${isDark ? '#4B5563' : '#9CA3AF'}; font-style: italic; }

      .s-input {
        width: 100%;
        background: ${isDark ? '#0F0F0F' : '#F9FAFB'};
        border: 1px solid ${isDark ? '#333' : '#D1D5DB'};
        border-radius: 10px;
        padding: 10px 14px;
        color: ${isDark ? '#fff' : '#111'};
        font-size: 14px; font-family: inherit; transition: border-color 0.2s;
        box-sizing: border-box;
      }
      .s-input:focus { outline: none; border-color: #FF4500; }
      .s-input::placeholder { color: ${isDark ? '#4B5563' : '#9CA3AF'}; }
      .s-select { appearance: none; cursor: pointer; }

      .s-code-pill {
        background: ${isDark ? '#0A0A0A' : '#F3F4F6'};
        border-radius: 12px;
        padding: 16px 24px; text-align: center; margin-bottom: 16px;
        display: flex; justify-content: center; gap: 2px;
      }
      .s-code-pill span {
        font-family: 'JetBrains Mono', 'Courier New', monospace;
        font-size: 32px; font-weight: 800; color: #FF4500;
        letter-spacing: 0.15em;
      }
      .s-code-actions { display: flex; gap: 8px; justify-content: center; margin-bottom: 8px; }
      .s-regen-row { text-align: center; margin-top: 8px; }
      .s-regen-confirm { text-align: center; }
      .s-regen-confirm p { font-size: 12px; color: #FCA5A5; margin-bottom: 8px; }

      .s-form-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; }
      .s-form-full { grid-column: 1 / -1; }
      .s-form-label {
        display: block; font-size: 10px; text-transform: uppercase;
        letter-spacing: 0.08em; color: ${isDark ? '#6B7280' : '#9CA3AF'};
        margin-bottom: 6px;
      }

      .s-toggle-row {
        display: flex; align-items: center; justify-content: space-between;
        padding: 12px 0; border-bottom: 1px solid ${isDark ? '#2A2A2A' : '#E5E7EB'};
      }
      .s-toggle-row:last-child { border-bottom: none; }
      .s-toggle-label { font-size: 14px; color: ${isDark ? '#fff' : '#111'}; }
      .s-toggle {
        width: 36px; height: 20px; border-radius: 10px;
        background: ${isDark ? 'rgba(255,255,255,0.12)' : 'rgba(0,0,0,0.12)'};
        border: none; position: relative; cursor: pointer; transition: background 0.2s; padding: 0;
      }
      .s-toggle.on { background: #FF4500; }
      .s-toggle-knob {
        display: block; width: 16px; height: 16px; border-radius: 50%;
        background: #fff; position: absolute; top: 2px; left: 2px;
        transition: transform 0.2s ease-out;
      }
      .s-toggle.on .s-toggle-knob { transform: translateX(16px); }

      .s-save-bottom {
        width: 100%; background: #FF4500; color: #fff; border: none;
        border-radius: 12px; padding: 14px; font-size: 14px;
        font-weight: 600; cursor: pointer; transition: opacity 0.2s;
        display: flex; align-items: center; justify-content: center; gap: 8px;
      }
      .s-save-bottom:hover { opacity: 0.9; }
      .s-save-bottom:disabled { opacity: 0.5; }

      @media (max-width: 640px) {
        .s-profile-card { flex-direction: column; gap: 16px; text-align: center; }
        .s-profile-center { text-align: center; }
        .s-header { flex-direction: column; gap: 12px; }
        .s-save-top { width: 100%; text-align: center; }
        .s-form-grid { grid-template-columns: 1fr; }
        .s-code-actions { flex-direction: column; }
      }
    `}</style>
  );
}
